module.exports = __webpack_public_path__ + "media/images/app/about/adam-09460c9b7e50bfb123449d14620598fd.webp";